// Copyright aptihealth, inc. 2019 All Rights Reserved
import React, { useState, useEffect } from "react";
import {
    Button,
    ButtonTypes,
    Dropdown,
    FormField,
    Modal,
    Text,
    TextColors,
    TextTypes,
} from "../../../component-library";
import { api } from "../../../APIRequests";

export const ChangePatientStatusPopUp = ({
    patientName,
    cancelHandler,
    confirmHandler,
    newPatientStatus,
    oldPatientStatus,
}) => {
    const [reasonSelected, setReasonSelected] = useState("");
    const [reasonDropdownValue, setReasonDropdownValue] = useState(null);
    const [reasonOptions, setReasonOptions] = useState([]);

    useEffect(() => {
        (async () => {
            const response = await api.public.get_patient_inactivation_reasons({
                params: { showLoader: true },
            });
            const sortedOptions = response.sort((optionA, optionB) =>
                optionA.label.localeCompare(optionB.label),
            );
            setReasonOptions(sortedOptions);
        })();
    }, []);

    const inactivatingPatientEmailInfo =
        'The patient will be notified by email, unless "Deceased" is selected.';

    return (
        <Modal className="ChangePatientStatus" show={true}>
            {newPatientStatus === "INACTIVE" ? (
                <div className="ChangePatientStatus__inactive">
                    <Text type={TextTypes.heading1} className={"mb-4"}>
                        You are inactivating {patientName}
                    </Text>

                    <FormField label="Reason for Inactivation" className={"mb-2"}>
                        <Dropdown
                            placeholder="Select Reason for Inactivation"
                            value={reasonDropdownValue}
                            options={reasonOptions}
                            onChange={(e) => {
                                setReasonDropdownValue({
                                    value: e.target.value,
                                    label: e.target.value,
                                });
                                setReasonSelected(e.target.value);
                            }}
                        />
                    </FormField>

                    <Text type={TextTypes.paragraph} color={TextColors.grey} className={"mb-4"}>
                        {inactivatingPatientEmailInfo}
                    </Text>

                    <div className="ChangePatientStatus__buttons">
                        <Button buttonType={ButtonTypes.primaryOutline} onClick={cancelHandler}>
                            Cancel
                        </Button>
                        <Button
                            buttonType={ButtonTypes.primary}
                            onClick={() => confirmHandler(reasonSelected)}
                            disabled={!reasonSelected}>
                            Inactivate Member
                        </Button>
                    </div>
                </div>
            ) : (
                <div className="ChangePatientStatus__active">
                    <Text type={TextTypes.heading1}>Activate Member</Text>

                    <div className="ChangePatientStatus__text">
                        <Text type={TextTypes.paragraph} color={TextColors.grey}>
                            Are you sure you want to activate {patientName}?
                        </Text>
                        <Text type={TextTypes.paragraph} color={TextColors.grey}>
                            Their status will be changed to their previous active status:{" "}
                            {oldPatientStatus}
                        </Text>
                    </div>

                    <div className="ChangePatientStatus__buttons">
                        <Button buttonType={ButtonTypes.primaryOutline} onClick={cancelHandler}>
                            No, Cancel
                        </Button>
                        <Button buttonType={ButtonTypes.primary} onClick={() => confirmHandler()}>
                            Yes, Activate Member
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
};
